import React, { MouseEventHandler, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';
import 'babel-polyfill';
import { redirectToError } from './util';
import { Appointment, IPersonalInfo } from './interfaces';
import FormWrapper from './formwrapper';
import { labels } from './labels';

const NewPatientCheck = () => {
    const urlParams = new URLSearchParams(window.location.search);

    const npi = urlParams.get('npi');
    const deptid = urlParams.get('deptid');
    const start = urlParams.get('start');    
    const backToUrl = urlParams.get('backto');

    const [appt, setAppt] = useState<Appointment>();
    const history = useHistory();

    useEffect(() => {
        axios.get(`api/appointments?npi=${npi}&deptid=${deptid}&start=${start}`)
            .then((result) => {
                if (!result.data) {
                    redirectToError(window.location.search, 'INVALID_APPT');
                    return;
                }
                setAppt(result.data);
            })
    }, [])

    if (!appt) {        
        return null;
    }

    return (
        <FormWrapper currentStep={1}>
            <h4 className="text-center mb-4">{labels.newpatient.heading.replace("${firstName}", appt.firstName)
                .replace("${lastName}", appt.lastName)
                .replace("${title}", appt.academicTitle ? ", " + appt.academicTitle : "")}</h4>
            {appt.photo && (<div className="text-center mb-4"><img src={(window as any).PHOTO_URL + appt.photo} alt={appt.firstName + " " + appt.lastName} style={{ width: "150px" }} /></div>)}
            <div className="mb-4">
                <Link to={{ pathname: "/search", search: backToUrl }} className="text-center">&larr; Back to Search Results</Link>                
            </div>

            <div className="row">
                <div className="col-md-12">

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <button className="btn btn-primary btn-block" type="submit" onClick={(e) => { e.preventDefault(); history.push(`personalinfo${window.location.search}`) }}>{labels.newpatient.notCurrentProvider}</button>
                        </div>
                        <div className="col-md-6 mb-3">
                            <button className="btn btn-outline-primary btn-block" type="submit" onClick={(e) => { e.preventDefault(); history.push(`contactprovider${window.location.search}`) }}>{labels.newpatient.currentProvider}</button>
                        </div>
                    </div>
                    <div className="mt-4">
                        {labels.general.callcenter}
                    </div>
                </div>
            </div>
        </FormWrapper>
    );
}

export default NewPatientCheck;